module.exports = __webpack_public_path__ + "img/小满.fcbf879c.png";